<template>
    <div>
        <div class="slds-grid">
            <div class="table-container slds-col slds-size_1-of-1">
                <table class="slds-table">
                    <thead id="data-column-header">
                        <tr class="slds-line-height_reset slds-border_bottom">
                            <th
                                class="slds-text-title_caps slds-cell-buffer_left slds-cell-buffer_right"
                                scope="col"
                            >
                                <div class="slds-truncate">
                                    <abbr
                                        class="slds-required"
                                        title="required"
                                    >*</abbr>Active
                                </div>
                            </th>
                            <th
                                class="slds-text-title_caps slds-cell-buffer_left slds-cell-buffer_right"
                                scope="col"
                            >
                                <div class="slds-truncate">
                                    <abbr
                                        class="slds-required"
                                        title="required"
                                    >*</abbr>Header Name
                                </div>
                            </th>
                            <th
                                class="slds-text-title_caps slds-cell-buffer_left slds-cell-buffer_right"
                                scope="col"
                            >
                                <div class="slds-truncate">
                                    <abbr
                                        class="slds-required"
                                        title="required"
                                    >*</abbr>Format As
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody id="data-columns">
                        <tr
                            v-for="column in columnFormat"
                            :key="column.index"
                            class="slds-hint-parent"
                        >
                            <td class="slds-cell-buffer_left slds-cell-buffer_right slds-form-element">
                                <MACheckbox
                                    v-model="column.active"
                                    :isDisabled="true"
                                    :value="column.active || column.spatial"
                                    noSlide
                                />
                            </td>
                            <td class="slds-cell-buffer_left slds-cell-buffer_right slds-form-element">
                                <div class="slds-p-vertical_x-small">
                                    {{ column.label }}
                                </div>
                            </td>
                            <td class="slds-cell-buffer_left slds-cell-buffer_right slds-form-element">
                                <div class="slds-p-vertical_x-small">
                                    {{ translateDataType(column.format) }}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

import MACheckbox from '@mapanything/ma-lib/src/vue/components/MACheckbox.vue';

export default {
    name: 'DataColumns',
    components: {
        MACheckbox
    },
    computed: {
        ...mapState({
            store__datasetReadOnly: 'datasetReadOnly'
        }),
        columnFormat() {
            const allColumns = [];

            this.store__datasetReadOnly.columnFormat.forEach((column) => {
                if (column.spatial) {
                    if (column.spatial === 'latitude' || column.spatial === 'longitude') {
                        column.format = 'decimal';
                    } else {
                        column.format = 'string';
                    }
                    column.active = true;
                }

                allColumns.push(column);
            });

            return allColumns;
        }
    },
    methods: {
        translateDataType(type) {
            const dataTypeMap = {
                url: 'URL',
                decimal: 'Decimal',
                boolean: 'Boolean',
                currency: 'Currency',
                string: 'Text',
                date: 'Date',
                integer: 'Integer'
            };

            return dataTypeMap[type];
        }
    }
};
</script>

<style lang="scss" scoped>
    .table-container {
        border: 1px solid #dddbda;
        border-radius: .25rem;
        overflow: hidden;
    }

    #data-columns .slds-form-element {
        margin-bottom: .25rem;
        margin-top: .25rem;
    }
</style>
